import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { invURL } from "../../components/Data/baseURL";
import { setLoadingStatus } from "./loadingStatusSlice";
import axiosInstance from "../../services/axios/axios";

export const getInvs = createAsyncThunk("invSlice/getInvs", async (params, { dispatch, rejectWithValue }) => {
  try {
    dispatch(setLoadingStatus(true));

    const response = await axiosInstance.get(invURL, { params: params });

    dispatch(setLoadingStatus(false));

    return response.data;
  } catch (error) {
    dispatch(setLoadingStatus(false));
    return rejectWithValue(error.response?.data);
  }
});

export const invSlice = createSlice({
  name: "invSlice",
  initialState: {
    inv: {},
    invs: [],
    statusInvs: null,
    changedTime: null,
  },
  reducers: {
    setInvs: (state, action) => {
      return { ...state, invs: [...action.payload] };
    },
    setInv: (state, action) => {
      return { ...state, inv: { ...action.payload } };
    },
    setStatus: (state, action) => {
      state.statusInvs = action.payload;
      return state;
    },
    addOrEditInv: (state, action) => {
      const i = state.invs.findIndex((inv) => inv.id === action.payload.id);
      if (i > -1) state.invs[i] = action.payload;
      else state.invs.unshift(action.payload);
      return state;
    },
    deleteInv: (state, action) => {
      const invs = state.invs.filter((inv) => inv.id !== action.payload);
      return { ...state, invs: [...invs] };
    },
  },
  extraReducers: {
    [getInvs.pending]: (state) => {
      state.statusInvs = "loading";
    },
    [getInvs.fulfilled]: (state, action) => {
      // state.invs = action.payload;
      console.log("RED6890", action.payload);
      state.statusInvs = "loaded";
    },
    [getInvs.rejected]: (state) => {
      state.statusInvs = "failed";
    },
  },
});

export const { setInvs, setInv, setStatus, addOrEditInv, deleteInv } = invSlice.actions;

export default invSlice.reducer;
